module.exports = __webpack_public_path__ + "img/welding-6.96ea7c7d.jpg";